<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-50" @close="$emit('close')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6">
                            <div>
                                <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                                    <i class="fa-solid fa-shield-check h-6 w-6 text-blue-500" aria-hidden="true"></i>
                                </div>
                                <div class="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">
                                        {{ title }}
                                    </DialogTitle>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500">
                                            {{ resolvedDescription }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-6 flex gap-2">
                                <button 
                                    type="button" 
                                    class="whiteButton w-1/2" 
                                    @click="$emit('close')"
                                    :disabled="isUpgrading"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    @click="$emit('upgrade')"
                                    :disabled="isUpgrading"
                                    class="primaryButton w-1/2 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <span v-if="isUpgrading" class="mr-2">
                                        <i class="fa fa-circle-notch fa-spin"></i>
                                    </span>
                                    {{ upgradeButtonText }}
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

export default {
    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        isUpgrading: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Upgrade to RiskGuard'
        },
        description: {
            type: String,
            default: null
        },
        upgradeButtonText: {
            type: String,
            default: 'Upgrade Now'
        }
    },
    emits: ['close', 'upgrade'],
    computed: {
        // RAC-10289: fall back to a live price from subscription_plans instead
        // of a hardcoded string, so this never drifts from the catalog again.
        resolvedDescription() {
            return this.description
                ?? `You've reached your free applicant report limit. Upgrade to RiskGuard to view unlimited reports. $${this.$page.props.subscription_prices.riskguard_monthly}/month. Cancel anytime.`
        }
    }
}
</script>

